import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  forgotPassword,
  getMe,
  loginUser,
  logoutUser,
  refreshToken,
  registerAsGuest,
  registerUser,
  resetPassword,
  updateUser,
} from "../Actions/authenticationActions";
import { setMessage } from "./message";
// import store from "../store";
// const user = JSON.parse(localStorage.getItem("user"));

// const accessToken = store.getState().auth.accessToken;

// export const register = createAsyncThunk(
//   "auth/register",
//   async (
//     { email, password, userId, courseId, firstname, lastname },
//     thunkAPI
//   ) => {
//     try {
//       const response = await registerUser(
//         email,
//         password,
//         userId,
//         courseId,
//         firstname,
//         lastname
//       );
//       if (response.ok) {
//         window.parent.postMessage("Success", "*");
//       }
//       return { user: response };
//     } catch (error) {
//       window.parent.postMessage("Fail", "*");
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.error.message) ||
//         error.message ||
//         error.toString();

//       thunkAPI.dispatch(
//         setMessage(
//           message === "Request failed with status code 400" &&
//           "Podany adres email już istnieje"
//         )
//       );
//       return thunkAPI.rejectWithValue();
//     }
//   }
// );

export const register = createAsyncThunk(
  "auth/register",
  async (
    { email, password, userId, courseId, firstname, lastname },
    thunkAPI,
  ) => {
    try {
      const response = await registerUser(
        email,
        password,
        userId,
        courseId,
        firstname,
        lastname,
      );

      console.log("Registration response:", response);

      window.parent.postMessage("Success", "*");

      return {
        user: response,
        jwt: response.jwt,
      };
    } catch (error) {
      console.error("Registration error:", error);
      console.error("Registration error response:", error?.response);
      console.error("Registration error data:", error?.response?.data);

      window.parent.postMessage("Fail", "*");

      const backendMessage =
        error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        error?.message ||
        error?.toString() ||
        "Wystąpił nieoczekiwany błąd.";

      const ERROR_MESSAGES = {
        "email must be a valid email":
          "Podany adres e-mail jest nieprawidłowy.",
        "email is required":
          "Adres e-mail jest wymagany.",
        "email must be unique":
          "Konto z podanym adresem e-mail już istnieje.",
        "user already exists":
          "Użytkownik o podanych danych już istnieje.",
        "user already registered":
          "Użytkownik jest już zarejestrowany.",
        "invalid email":
          "Podany adres e-mail jest nieprawidłowy.",
        "invalid email address":
          "Podany adres e-mail jest nieprawidłowy.",
        "invalid password":
          "Podane hasło jest nieprawidłowe.",
        "password is too short":
          "Hasło jest zbyt krótkie.",
        "user not found":
          "Nie znaleziono użytkownika.",
        "course not found":
          "Nie znaleziono kursu.",
        "registration failed":
          "Rejestracja nie powiodła się.",
      };

      const normalizedMessage = String(backendMessage).toLowerCase();

      const translationKey = Object.keys(ERROR_MESSAGES).find(
        (key) => normalizedMessage.includes(key.toLowerCase()),
      );

      const message = translationKey
        ? ERROR_MESSAGES[translationKey]
        : backendMessage;

      thunkAPI.dispatch(setMessage(message));

      return thunkAPI.rejectWithValue({
        message,
      });
    }
  },
);



export const registerasguest = createAsyncThunk(
  "auth/registerAsGuest",
  async ({ email, password, firstname, lastname, userRole }, thunkAPI) => {
    try {
      const response = await registerAsGuest(
        email,
        password,
        firstname,
        lastname,
        userRole,
      );

      return {
        user: response,
        jwt: response.jwt,
      };
    } catch (error) {
      const backendMessage =
        error.response?.data?.error?.message ??
        error.response?.data?.message ??
        error.message ??
        "Wystąpił błąd podczas rejestracji.";

      console.error("Rejestracja gościa:", backendMessage);

      const message = String(backendMessage)
        .toLowerCase()
        .includes("email or username are already taken")
        ? "Konto z podanym adresem e-mail lub nazwą użytkownika już istnieje."
        : backendMessage;

      thunkAPI.dispatch(setMessage(message));

      return thunkAPI.rejectWithValue({ message });
    }
  },
);

export const login = createAsyncThunk(
  "auth/login",
  async ({ username, password }, thunkAPI) => {
    try {
      // const data = await loginUser(username, password);
      // return { user: data };
      const data = await loginUser(username, password);
      return data;
    } catch (error) {
      console.error(error.response.data.error);
      let message;
      if (
        error.response.data.error &&
        error.response.data.error.message ===
        "Your account email is not confirmed"
      ) {
        message = "Potwierdź konto przez Twój email";
      } else if (error.response.data.error.status) {
        message = "Podałeś niepoprawne dane";
      }
      // const message =
      //   (error.response &&
      //     error.response.data &&
      //     error.response.data.message) ||
      //   error.message ||
      //   error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const getCurrentUser = createAsyncThunk(
  "auth/getCurrentUser",
  async ({ token }, thunkAPI) => {
    try {
      const data = await getMe(token);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  },
);

export const update = createAsyncThunk(
  "auth/update",
  async ({ id, token, payload }, thunkAPI) => {
    try {
      const data = await updateUser(id, token, payload);
      return data;
    } catch (error) {
      console.error(error.response.data.error);
      let message;
      if (error.response.data.error.status) {
        message = "Podałeś niepoprawne dane";
      }
      // const message =
      //   (error.response &&
      //     error.response.data &&
      //     error.response.data.message) ||
      //   error.message ||
      //   error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

// export const change = createAsyncThunk(
//   "auth/change-password",
//   async ({id, token, payload}, thunkAPI) => {
//       console.log(id, token, payload)
//     try {
//       console.log(id, token, payload)
//       const data = await changePassword(id, token, payload);
//       console.log(data)
//       return  data;
//     } catch (error) {
//       console.error(error.response.data.error)
//       let message;
//       if(error.response.data.error.status){
//         message = 'Podałeś niepoprawne dane'
//       }
//       // const message =
//       //   (error.response &&
//       //     error.response.data &&
//       //     error.response.data.message) ||
//       //   error.message ||
//       //   error.toString();
//         console.log(message)
//       thunkAPI.dispatch(setMessage(message));
//       return thunkAPI.rejectWithValue();
//     }
//   }
// );

export const reset = createAsyncThunk(
  "auth/reset-password",
  async ({ code, password, repeatPassword }, thunkAPI) => {
    try {
      const data = await resetPassword({ code, password, repeatPassword });
      return data;
    } catch (error) {
      console.error(error.response.data.error);
      let message;
      if (error.response.data.error.status) {
        message = "Podałeś niepoprawne dane";
      }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const forgot = createAsyncThunk(
  "auth/forgot-password",
  async (payload, thunkAPI) => {
    try {
      const data = await forgotPassword(payload);
      return data;
    } catch (error) {
      console.error(error.response.data.error);
      let message;
      if (error.response.data.error.status) {
        message = "Podałeś nieprawidłowy adres email";
      }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const refresh = createAsyncThunk("auth/refresh", async (_, thunkAPI) => {
  try {
    const data = await refreshToken();

    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue();
  }
});

export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { getState }) => {
    const jwt = getState().auth.accessToken;

    await logoutUser(jwt);
  },
);

// const initialState = user
//   ? { isLoggedIn: true, user }
//   : { isLoggedIn: false, user: null };

const initialState = {
  isLoggedIn: false,
  user: null,
  accessToken: null,
  isInitializing: true,
};

// const authSlice = createSlice({
//   name: "auth",
//   initialState,
//   extraReducers: {
//     [register.fulfilled]: (state, action) => {
//       state.isLoggedIn = true;
//       state.user = action.payload.user;
//     },
//     [register.rejected]: (state, action) => {
//       state.isLoggedIn = false;
//     },
//     [login.fulfilled]: (state, action) => {
//       state.isLoggedIn = true;
//       state.user = action.payload.user;
//     },
//     [login.rejected]: (state, action) => {
//       state.isLoggedIn = false;
//       state.user = null;
//     },
//     [logout.fulfilled]: (state, action) => {
//       state.isLoggedIn = false;
//       state.user = null;
//     },
//     [update.fulfilled]: (state, action) => {
//       state.isLoggedIn = true;
//       state.user = action.payload;
//     },
//     [update.rejected]: (state, action) => {
//       state.user = null;
//       // state.user = state.user;
//     },
//   },
// });

const authSlice = createSlice({
  name: "auth",
  initialState,

  extraReducers: {
    [register.fulfilled]: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload.user;
      state.accessToken = action.payload.jwt;
      state.error = null;
    },
    [register.rejected]: (state, action) => {
      state.isLoggedIn = false;
      state.user = null;
      state.accessToken = null;
      state.error =
        action.payload?.message ||
        action.error?.message ||
        "Wystąpił błąd podczas rejestracji.";
    },

    [login.fulfilled]: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload.user;
      state.accessToken = action.payload.jwt;
      state.isInitializing = false;
    },

    [login.rejected]: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.accessToken = null;
      state.isInitializing = false;
    },

    [refresh.fulfilled]: (state, action) => {
      // console.log("REFRESH PAYLOAD:", action.payload);

      state.isLoggedIn = true;
      state.accessToken = action.payload.jwt;
      state.isInitializing = true;
    },

    [refresh.rejected]: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.accessToken = null;
      state.isInitializing = false;
    },

    [getCurrentUser.fulfilled]: (state, action) => {
      // console.log("GET ME USER:", action.payload);

      state.isLoggedIn = true;
      state.user = action.payload;
      state.isInitializing = false;
    },

    [getCurrentUser.rejected]: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.accessToken = null;
      state.isInitializing = false;
    },

    [logout.fulfilled]: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.accessToken = null;
    },

    [update.fulfilled]: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload;
    },

    [update.rejected]: (state) => {
      state.user = null;
    },
  },
});

const { reducer } = authSlice;
export default reducer;
